import { API, auth } from './api';

const sessions = new Map();
export function familyAiClient(kind = 'user') {
  const prefix = `${API}/${kind}/family-ai`;
  const token = () => kind === 'admin' ? auth.getAdmin() : auth.getUser();
  const key = () => `${kind}:${token()}`;
  async function session(force = false) {
    if (!force && sessions.get(key())) return sessions.get(key());
    const response = await fetch(prefix + '/session', { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
    const data = await response.json(); if (!response.ok) throw new Error(data.detail || 'تعذر فتح المساعد.');
    sessions.set(key(), data.session); return data.session;
  }
  async function raw(path, options = {}, retry = true) {
    const grant = await session();
    const response = await fetch(prefix + path, { ...options, headers: { Authorization: `Bearer ${token()}`, 'X-Family-AI-Session': grant, ...(options.body && !(options.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}), ...options.headers } });
    if (response.status === 401 && retry) { await session(true); return raw(path, options, false); }
    return response;
  }
  async function request(path, method = 'GET', body) {
    const response = await raw(path, { method, ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {}) });
    const data = await response.json(); if (!response.ok) throw new Error(data.detail || 'تعذر إكمال الطلب.'); return data;
  }
  async function download(file, preview = false) {
    const response = await raw(`/files/${file.id}${preview ? '?preview=1' : ''}`); if (!response.ok) throw new Error('تعذر تحميل الملف.');
    const url = URL.createObjectURL(await response.blob());
    if (preview) return url;
    const link = document.createElement('a'); link.href = url; link.download = file.name; link.click(); setTimeout(() => URL.revokeObjectURL(url), 30000);
  }
  async function stream(job, after, onEvent, signal) {
    const response = await raw(`/jobs/${job}/events?after=${after}`, { signal });
    if (!response.ok) throw new Error('تعذر استئناف بث الإجابة.');
    const reader = response.body.getReader(), decoder = new TextDecoder(); let buffer = '';
    try { while (true) { const { value, done } = await reader.read(); buffer += decoder.decode(value || new Uint8Array(), { stream: !done }).replace(/\r/g, ''); let boundary;
      while ((boundary = buffer.indexOf('\n\n')) >= 0) { const lines = buffer.slice(0, boundary).split('\n'); buffer = buffer.slice(boundary + 2); const data = lines.find(l => l.startsWith('data:')); if (!data) continue; onEvent({ id: Number(lines.find(l => l.startsWith('id:'))?.slice(3)) || 0, type: lines.find(l => l.startsWith('event:'))?.slice(6).trim(), data: JSON.parse(data.slice(5)) }); }
      if (done) break;
    } } finally { reader.releaseLock(); }
  }
  // A per-session namespace prevents another signed-in account restoring stale UI state.
  const storageScope = () => { let hash=2166136261;for(const c of token()||'')hash=Math.imul(hash^c.charCodeAt(0),16777619);return `${kind}_${hash>>>0}`; };
  return { request, download, stream, session, storageScope };
}
